module.exports = __webpack_public_path__ + "node_modules/icheck/skins/square/yellow.png?251d5e87";